import { message, Modal } from 'antd';
import React from 'react';
import { simpleDelete } from 'common/utils/http';
import { AttributeNameValPair, DerivedAttributePair, DerivedAttributeMap } from '../interfaces';
import PaneHeader from '../../components/PaneHeader';
import PaneItem from './PaneItem';

interface Props {
  addNew: () => void;
  paneName: string;
  paneItems?: AttributeNameValPair[];
  selectedAttr?: DerivedAttributeMap;
  reload: () => Promise<void>;
}

const deleteDerivedAttribute: (attrPair: DerivedAttributePair) => Promise<void> = attrPair =>
  simpleDelete('/api/v1/derived', attrPair);

const DerivedPane = ({ paneName, paneItems, addNew, selectedAttr, reload }: Props) => {
  const deleteAttr = async (attr: AttributeNameValPair) => {
    Modal.confirm({
      title: 'Are you sure you want to delete this derived attribute?',
      content: 'The deletion cannot be undone.',
      okText: 'Yes',
      okType: 'danger',
      cancelText: 'No',
      onOk: async () => {
        try {
          if (selectedAttr) {
            await deleteDerivedAttribute({
              attribute: selectedAttr.attribute,
              derived: attr,
            });
            reload();
          }
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        catch (e: any) {
          message.error(e.error);
        }
      },
    });
  };

  return (
    <div style={{ width: '50vw', display: 'flex', flexDirection: 'column' }}>
      <PaneHeader onAdd={addNew} paneName={paneName} />
      <div style={{ padding: '10px', overflow: 'auto' }}>
        {selectedAttr &&
          paneItems &&
          paneItems.map(item => (
            <PaneItem item={item} key={JSON.stringify(item)} onDelete={() => deleteAttr(item)} />
          ))}
      </div>
    </div>
  );
};

export default DerivedPane;
